document.addEventListener('turbolinks:load', () => {

  const algoliasearch = require('algoliasearch');
  const autocomplete = require('autocomplete.js');

  var application_id = gon.application_id;
  var search_only_api_key = gon.search_only_api_key;

  const config = {
    application_id: application_id,
    search_only_api_key: search_only_api_key,
  };

  var client = algoliasearch(config.application_id, config.search_only_api_key);
  
  function newHitsSource(index, params) {
    return function doSearch(query, cb) {
      index
        .search(query, params)
        .then(function(res) {
          cb(res.hits, res);
        })
        .catch(function(err) {
          console.error(err);
          cb([]);
        });
    };
  }

  // var itemIndex = client.initIndex('Item');
  // autocomplete('#query_item', { hint: false }, [
  //   {
  //     source: newHitsSource(itemIndex, { hitsPerPage: 5 }),
  //     displayKey: 'purpose',
  //     templates: {
  //       suggestion: function(suggestion) {
  //         return `${suggestion._highlightResult.purpose.value}  ${suggestion._highlightResult.memo.value}`;
  //         // return `${suggestion._highlightResult.public_uid}`
  //       }
  //     }
  //   }
  // ]).on('autocomplete:selected', function(event, suggestion, dataset, context) {
  //   if (context.selectionMethod === 'click') {
  //     window.location.assign(`/items/${suggestion.public_uid}`);
  //     return;
  //   }
  // });


  var customerIndex = client.initIndex('Customer');
  // console.log(customerIndex);
  autocomplete('#query_customer', { hint: false }, [
    {
      source: newHitsSource(customerIndex, { hitsPerPage: 5 }),
      displayKey: 'name',
      templates: {
        suggestion: function(suggestion) {
          console.log(suggestion._highlightResult)
          return `${suggestion._highlightResult.name.value}`;
          // return `${suggestion._highlightResult.public_uid}`
        }
      }
    }
  ]).on('autocomplete:selected', function(event, suggestion, dataset, context) {
    if (context.selectionMethod === 'click') {
      window.location.assign(`/customers/${suggestion.objectID}`);
      return;
    }
  });
})